import { Reposition } from '@/helpers/storeHelper'

export default {
  removeSection({ state, commit, dispatch, getters }, { id = null, stack = 'undo', stackToClear = 'redo' } = {}) {
    if (!id) {
      return
    }

    const section = getters.objectById(id)
    const canRemoveSection = section.children.length === 0 && !section.path

    if (canRemoveSection) {
      const siblings = state.landing.filter(l => l.type === 'Section' && l.id !== id)

      const reposition = Reposition(siblings, section.options, (crr, ref) => crr > ref, -1)

      if (getters.isActive(id)) {
        dispatch('setActive')
      }

      commit('remove', id)
      commit('reposition', reposition)
      dispatch(
        'history/pushToStack',
        {
          stack,
          action: 'landing/addSection',
          params: { id, options: section.options },
          stackToClear,
        },
        { root: true }
      )
    }
  },

  removePanel({ commit, dispatch, getters }, { id = null, stack = 'undo', stackToClear = 'redo' } = {}) {
    if (!id) {
      return
    }

    const panel = getters.objectById(id)
    const parentId = panel.path[panel.path.length - 1]

    const canRemovePanel = panel.children.length === 0

    if (canRemovePanel) {
      const siblings = getters.objectById(parentId).children.map(c => getters.objectById(c))

      const reposition = Reposition(siblings, panel.options, (crr, ref) => crr > ref, -1)

      if (getters.isActive(id)) {
        dispatch('setActive')
      }

      commit('remove', id)
      commit('reposition', reposition)

      dispatch(
        'history/pushToStack',
        {
          stack,
          action: 'landing/addPanel',
          params: { id, parentId, options: panel.options },
          stackToClear,
        },
        { root: true }
      )
    }
  },

  removeWidget({ commit, dispatch, getters }, { id = null, stack = 'undo', stackToClear = 'redo' } = {}) {
    if (!id) {
      return
    }

    const widget = getters.objectById(id)
    const parentId = widget.path[widget.path.length - 1]

    if (getters.isActive(id)) {
      dispatch('setActive')
    }

    commit('remove', id)
    commit('updateTitle', { id: parentId, value: 'Painel' })

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/addWidget',
        params: { id, parentId, type: widget.type, options: widget.options },
        stackToClear,
      },
      { root: true }
    )
  },

  removeTabs({ commit, dispatch, getters }, { id = null, stack = 'undo', stackToClear = 'redo' } = {}) {
    if (!id) {
      return
    }

    const descendants = getters.descendants(id)
    const idsToRemove = [...descendants.map(descendant => descendant.id), id]
    commit('removeTabs', { ids: idsToRemove })

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/addTabs',
        params: { id },
        stackToClear,
      },
      { root: true }
    )
  },

  removeTabsItem({ commit, dispatch, getters }, { id, index, stack = 'undo', stackToClear = 'redo' } = {}) {
    if (!id) {
      return
    }

    const tabs = getters.objectById(id)
    const releatedSectionId = tabs.children[index]
    commit('remove', releatedSectionId)
    commit('removeTabsItem', { id, index })

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/addTabsItem',
        params: { id, index },
        stackToClear,
      },
      { root: true }
    )
  },

  removeHeroSparkBanner({ commit, dispatch, getters }, { id = null, stack = 'undo', stackToClear = 'redo' } = {}) {
    if (!id) return

    const descendants = getters.descendants(id)
    const idsToRemove = [...descendants.map(descendant => descendant.id), id]

    commit('removeHeroSparkBanner', { ids: idsToRemove })

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/addHeroSparkBanner',
        params: { id },
        stackToClear,
      },
      { root: true }
    )
  },
}
